import React from "react";
import { Modal } from "antd";

const BasicModal = ({ title, isOpen, onCancel, width = 416, children }) => {
  return (
    <>
      <Modal
        destroyOnClose
        title={title}
        open={isOpen}
        onCancel={onCancel}
        footer={null}
        width={width}
      >
        {children}
      </Modal>
    </>
  );
};

export default BasicModal;
